import * as rlpp from 'rlp'
import keccak from 'keccak'
export function getNewContractAddress(ethAddress, nonce) {
  var input_arr = [ethAddress, nonce];
  let rlp=rlpp.rlp
  var rlp_encoded = rlpp.encode(input_arr);
  var contract_address_long = keccak('keccak256').update(rlp_encoded).digest('hex');
  var contract_address = contract_address_long.substring(24); //Trim the first 24 characters.
  console.log({ethAddress,nonce,contract_address})
  //@ts-ignore
  return web3.utils.toChecksumAddress(contract_address);
}
export function getNewRandomContractAddress(ethAddress) {
  //@ts-ignore
  return web3.utils.toChecksumAddress(getRandomHex(40))
}


function getRandomHex(length) {
  const characters = '0123456789ABCDEF';
  let result = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }
  return result;
}
